<template>
  <div>
    <div class="flex">
      <div class="pt-4" v-if="isAdmin">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="username">Zgjedhe User-in:</label>
        <div class="inline-block relative">
          <select
            class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
            v-model="user"
          >
            <option>Zgjedh</option>
            <option v-for="(user, id) in users" :value="user.id" :key="id">{{user.name}}</option>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>
      <div class="pl-4 pt-4">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="username">Zgjedhe Muajin:</label>
        <div class="inline-block relative">
          <select
            class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
            v-model="month"
          >
            <option>Zgjedh</option>
            <option v-for="(month, id) in months" :value="month.id" :key="id">{{month.name}}</option>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div class="pt-4 flex">
      <button
        @click="getMonthlyRatings"
        class="block m-1 uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
      >FILTRO</button>
      <vue-excel-xlsx
        class="block m-1 uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
        :data="ratings"
        :columns="columns"
      >
        <i class="fa fa-file-excel"></i>
        Export Excel
      </vue-excel-xlsx>
      <!-- <div class="pl-4 pt-4"> -->
      <a
        type="button"
        target="_blank"
        class="block m-1 uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
        :href="'https://api.homeface.dev/monthly-ratings/' + month + '/' + user"
      >Eksport PDF</a>
      <router-link
        to="/excel"
        class="block m-1 uppercase focus:outline-none shadow bg-teal-400 hover:bg-teal-300 text-white text-xs py-2 px-5 rounded"
      >Kthehu</router-link>
      <!-- </div> -->
    </div>

    <div class="py-6">
      <table class="min-w-full">
        <thead>
          <tr>
            <th
              class="px-2 py-2 w-4 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
            >NR</th>
            <th
              class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
            >M1</th>
            <th
              class="px-2 py-2 border w-1/6 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
            >KOMENT M1</th>
            <th
              class="px-2 py-2 border w-4 border-gray-400 bg-gray-50 text-left text-xs leading-4 font-bold text-gray-800 uppercase tracking-wider"
            >BZ</th>
            <th
              class="px-2 py-2 border w-1/6 border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
            >KOMENT BZ</th>
            <th
              class="px-2 py-2 w-4 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
            >M3</th>
            <th
              class="px-2 py-2 border w-1/6 border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
            >KOMENT M3</th>
            <th
              class="px-2 py-2 w-4 border border-gray-400 bg-gray-50 text-left text-xs font-bold leading-4 text-gray-800 uppercase tracking-wider"
            >DITA</th>
          </tr>
        </thead>
        <tbody class="bg-white">
          <tr v-for="(rating, index) in ratings" :key="index.id">
            <td class="px-2 py-2 whitespace-no-wrap border border-gray-400">{{index+1 }}</td>
            <td class="px-2 py-2 whitespace-no-wrap border border-gray-400">{{rating.m1}}</td>
            <td class="px-2 py-2 border border-gray-400">{{rating.comment_m1}}</td>
            <td class="px-2 py-2 whitespace-no-wrap border border-gray-400">{{rating.bz}}</td>
            <td class="px-2 py-2 border border-gray-400">{{rating.comment_bz}}</td>
            <td class="px-2 py-2 whitespace-no-wrap border border-gray-400">{{rating.m3}}</td>
            <td class="px-2 py-2 border border-gray-400">{{rating.comment_m3}}</td>
            <td
              class="px-2 py-2 whitespace-no-wrap border border-gray-400"
            >{{rating.day | filter-rating-date}}</td>
          </tr>
          <tr>
            <td class="px-2 py-2 border border-gray-400"></td>
            <td class="px-2 py-2 border border-gray-400">{{ total.m1 }}</td>
            <td class="px-2 py-2 border border-gray-400"></td>
            <td class="px-2 py-2 border border-gray-400">{{ total.bz }}</td>
            <td class="px-2 py-2 border border-gray-400"></td>
            <td class="px-2 py-2 border border-gray-400">{{ total.m3 }}</td>
            <td class="px-2 py-2 border border-gray-400"></td>
            <td class="px-2 py-2 border border-gray-400">Total: {{ total.totali }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  components: {},
  data() {
    return {
      isAdmin: false,
      ratings: [],
      total: {},
      user_id: "",
      users: [],
      // id: null,
      user: null,
      //   date: new Date(),
      month: moment().month() + 1,
      months: [
        { id: 1, name: "Janar" },
        { id: 2, name: "Shkurt" },
        { id: 3, name: "Mars" },
        { id: 4, name: "Prill" },
        { id: 5, name: "Maj" },
        { id: 6, name: "Qershor" },
        { id: 7, name: "Korrik" },
        { id: 8, name: "Gusht" },
        { id: 9, name: "Shtator" },
        { id: 10, name: "Tetor" },
        { id: 11, name: "Nentor" },
        { id: 12, name: "Dhjetor" }
      ],
      url: "",
      columns: [
        { label: "M1", field: "m1" },
        { label: "M1 COMENT", field: "comment_m1" },
        { label: "BZ", field: "bz" },
        { label: "BZ COMENT", field: "comment_bz" },
        { label: "M3", field: "m3" },
        { label: "M3 COMENT", field: "comment_m3" },
        { label: "DAY", field: "day", dataFormat: this.excelFormat }
      ],
      object3: {}
    };
  },
  created() {
    this.getUser();
    this.getUsers();
    this.getMonthlyRatings();
  },
  methods: {
    getUser() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios.get(`${process.env.VUE_APP_API}/user`).then(response => {
        if (
          response.data.data.id === 3 ||
          response.data.data.id === 1 ||
          response.data.data.id === 12
        ) {
          this.isAdmin = true;
        }

        this.user = response.data.data.id;
      });
    },
    getUsers() {
      axios
        .get(`${process.env.VUE_APP_API}/excel/users`)
        .then(response => {
          this.users = response.data;
          //   console.log(response.data);
        })
        .catch(error => console.log(error));
    },
    getMonthlyRatings() {
      this.user === null
        ? (this.url = `${process.env.VUE_APP_API}/excel/vlersimet-mujore?month=${this.month}`)
        : (this.url = `${process.env.VUE_APP_API}/excel/vlersimet-mujore?month=${this.month}&user_id=${this.user}`);

      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .get(this.url)
        .then(response => {
          console.log(response);
          this.ratings = response.data.vleresimet;
          this.total = response.data;
        })
        .catch(error => console.log(error));

      this.object3 = { ...this.ratings, ...this.total };
      Object.keys(this.object3);
      console.log(this.object3);
      // console.log("test");
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    excelFormat(value) {
      return moment(value).format("DD-MM-YYYY");
    },
    checkUser() {
      console.log(this.user);
    }
  }
};
</script>

<style>
</style>